<template>
  <div class="flex flex-column align-items-center justify-content-center pt-3 pb-3">
    <PrimevueCard  class="sm:w-12 md:w-11 lg:w-11 xl:w-8 mb-2">
        <template #title>
          <div class="align-items-center flex justify-content-between ">
              <div v-if="this.routeParams.typ == 1" >ŽIADOSŤ O REZERVÁCIU</div>
              <div v-if="this.routeParams.typ == 2" >ŽIADOSŤ O PRESTRIEKANIE</div>
              <PrimevueTag class="p-2 ml-1 font-medium text-base justify-content-center" 
                           :value="reservationRequest.status"
                           :severity="reservationRequest.status == 'Nová' ? 'primary' : (reservationRequest.status == 'Rozpracovaná' ? 'warning' : 'success')" />
          </div>
        </template>
        <template #subtitle >
            <div class="mb-3 border-solid border-1 surface-border">
            </div>
        </template>
        <template #content>
        <!--    
            <form @submit.prevent="submitHandler" name="packageForm">
            </form>  
        -->
          <div class="flex flex-wrap">
                
            <div class="w-12 md:w-6 lg:w-6 xl:w-6 p-1">  

              <div class="w-full mt-4" style="position: relative;">
                
                <div class="field mb-3 ">
                  <label class="mb-1" for="res-req-order">Objednávka</label>
                  <PrimevueButton @click="initOrders()" 
                      :disabled="!(this.routeParams.resReqId == '0')"
                      style="height: 2rem;"
                      class="flex justify-content-between w-full " outlined
                      id="res-req-order">

                    <span v-if="selectedOrder">{{this.selectedOrder.orderCode}}</span>
                    <span v-if="!selectedOrder">Vyber objednávku</span>

                    <span class="flex justify-content-center align-items-center" style="width: 1.8rem;">
                      <svg width="14" height="14" viewBox="0 0 14 14" 
                            fill="none" xmlns="http://www.w3.org/2000/svg" class="p-icon p-button-icon">
                            <path d="M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z" fill="currentColor"></path>
                      </svg>
                    </span>

                  </PrimevueButton>

                  <div v-if="visibleSelect" class="card" 
                      style="z-index: 10; position: absolute; top: 30px; left: 1px; min-width: 20rem; transform-origin: center top; margin-top: 2px;">
            
                        <IconField iconPosition="left">
                        
                          <InputIcon>
                            <i class="pi pi-search "/>
                          </InputIcon>
                          <InputText v-model="orderFilters['global'].value" placeholder="Vyhľadať" @input="onOrderFilter()" 
                        
                          />
                        </IconField>
                      <!-- </div> -->
                    <DataTable
                        
                        lazy paginator :rows="selectParams.rows"
                        @page="onOrderPage($event)"
                        :first="selectParams.first"
                        :loading="selectLoading"
                        :totalRecords="selectParams.totalRecords"
                        dataKey="id"
                        :value="orderOptions"
                        :scrollHeight="`${200}px`"
                        :virtualScrollerOptions="{ itemSize: 40 }"
                        stripedRows
                        row-hover
                        scrollable
                        v-model:selection="selectedOrder"
                        selectionMode="single"
                        :metaKeySelection="false"
                        @rowSelect="selectOrder()"
                        size="small"
                    >
                        <Column header="ID" field="orderCode" style="width: 5%">
                        </Column>
                        <Column header="Meno" field="customer.lastName" style="width: 50%">
                        </Column>    
                        <Column header="Obec" field="customer.city" style="width: 45%">
                        </Column>              
                    </DataTable>              
                  </div>
                </div>
                
                <div class="field mb-3">
                  <label class="mb-1" for="res-req-customer">Zákazník</label>
                  <InputText class="w-full" 
                    disabled
                    :placeholder="reservationRequest.order.customerLastName +' '+reservationRequest.order.customerFirstName"
                    type="text"
                    name="res-req-customer"
                    id="res-req-customer"
                  >
                  </InputText>
                </div>

                <div class="field mb-1">
                  <div class="flex align-items-center justify-content-between" style="margin-bottom: 0rem;">
                    <span class="mb-1">{{this.routeParams.typ == 1 ? 'Farba' : 'Nová farba'}}</span>
                    <div class="flex align-items-center justify-content-right"> 
                      <label for="imitation" class="mr-2 mb-1">Imitácia dreva</label>
                      <PrimevueCheckbox 
                        :disabled="!selectedOrder || !(this.routeParams.resReqId == '0')"
                        v-model="imitation" inputId="imitation" name="imitation" :binary="true"
                        @change="setColors()"
                      />
                      
                    </div>
                  </div>
                  <PrimevueSelect
                      id="req-color"
                      :disabled="!selectedOrder || !(this.routeParams.resReqId == '0')"
                      @change="this.routeParams.typ == 1 ? filterProducts(selectedColor.id) : null"
                      v-model="selectedColor"
                      :options="colors"
                      optionLabel="code"
                      placeholder="Vyber farbu"
                      class="w-full"
                      :class="`${v$.selectedColor.$error ? 'bg-red-200' : ''}`"
                      :invalid="v$.selectedColor.$error"
                  >
                  <template #value="slotProps">
                    <div v-if="slotProps.value.id != 0" class="flex align-items-center">
                        <div
                          class="color-box mr-2"
                          :style="{ backgroundColor: slotProps.value.colorHash }"
                        ></div>  
                        <div>{{ slotProps.value.code }}</div>
                    </div>
                    <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
                  </template>
                  <template #option="slotProps">
                      <div class="flex align-items-center">
                          <div
                            class="color-box mr-2"
                            :style="{ backgroundColor: slotProps.option.colorHash }"
                          ></div>  
                          <div>{{ slotProps.option.code }}</div>
                      </div>
                  </template>
                  </PrimevueSelect>
                  <div
                    v-for="(error, index) of v$.selectedColor.$errors"
                    :key="index"
                    class="text-sm font-italic text-red-400"
                  >
                    {{ error.$message }}
                  </div>
                </div>

              </div>  
            </div> 

            <div class="w-12 md:w-6 lg:w-6 xl:w-6 p-1">  
              <Fieldset :legend="this.routeParams.typ == 1 ? 'Vyžiadanie rezervácie profilov' : 'Vyžiadanie prestriekania profilov'"  class="">
                <div class=" w-full ml-0 mr-0">
                  <div class="grid ml-0 mr-0">
                    <div class="col-10 pl-0 pr-1 pb-0">
                      <div class="field mb-1">
                        <label class="mb-1" for="res-req-product">Produkt</label>
                        
                        <PrimevueSelect
                              id="res-req-product"
                              :disabled="!selectedColor.code || !(store.user.admin === true || store.user.department.id == 3)"
                              v-model="selectedProduct"
                              filter
                              :options="productOptions"
                              optionLabel="product.code"
                              placeholder="Vyber produkt"
                              class="w-full"
                              :class="`${v$.selectedProduct.product.code.$error ? 'bg-red-200' : ''}`"
                              :invalid="v$.selectedProduct.product.code.$error"
                             
                          >
                            <template #value="slotProps">
                              <div v-if="slotProps.value.id != 0" class="">
                                  <div class="text-sm">{{ slotProps.value.product.code }} 
                                      - {{ slotProps.value.product.name.length > 26 ? slotProps.value.product.name.slice(0, 26) + '...' : slotProps.value.product.name }} 
                                      - {{ slotProps.value.numberOfItem }}</div>
                              </div>
                              <span v-else>
                                <div class="text-sm">{{ slotProps.placeholder }}</div>
                              </span>
                            </template>
                            <template #option="slotProps">
                                <div class="text-sm">
                                  <div>{{ slotProps.option.product.code }} - {{ slotProps.option.product.name }} - {{ slotProps.option.numberOfItem }}</div>
                                </div>
                            </template>
                        </PrimevueSelect>  

                      </div>                            
                    </div>

                    <div class="col-2 pr-0 pl-0 pb-0">
                      <div class="field mb-1">
                        <label class="mb-1" for="product-number">Počet</label>
                        <InputNumber inputId="product-number" :useGrouping="false"
                          :disabled="!(selectedProduct.id > 0)"
                          v-model="numberOfProd"
                          name="product-number"
                          id="product-number"
                          :inputClass="`${v$.numberOfProd.$error ? 'text-sm bg-red-200 w-full' : 'text-sm w-full'}`"
                          :invalid="v$.numberOfProd.$error"
                        >
                        </InputNumber>

                      </div>            
                    </div>

                    <div
                        v-for="(error, index) of v$.numberOfProd.$errors"
                        :key="index"
                        class="text-sm font-italic text-red-400"
                    >
                      {{ error.$message }}
                    </div>
                  </div>

                  <div v-if="false" class="field mt-2">
                    <div class="flex align-items-center justify-content-between" style="margin-bottom: 0rem;">
                      <span class="mb-1">Farba</span>
                      <div class="flex align-items-center justify-content-right"> 
                        <label for="imitation" class="mr-2 mb-1">Imitácia dreva</label>
                        <PrimevueCheckbox 
                          :disabled="!(selectedProduct.id > 0)"
                          v-model="imitation" inputId="imitation" name="imitation" :binary="true"
                          @change="setColors()"
                        />
                        
                      </div>
                    </div>
                    <PrimevueSelect
                        id="req-spray-color"
                        :disabled="!(selectedProduct.id > 0)"
                        @change="filterProducts(selectedColor.id)"
                        v-model="selectedColor"
                        :options="colors"
                        optionLabel="code"
                        placeholder="Vyber farbu"
                        class="w-full"
                        :class="`${v$.selectedColor.$error ? 'bg-red-200' : ''}`"
                        :invalid="v$.selectedColor.$error"
                    >
                    <template #value="slotProps">
                      <div v-if="slotProps.value.id != 0" class="flex align-items-center">
                          <div
                            class="color-box mr-2"
                            :style="{ backgroundColor: slotProps.value.colorHash }"
                          ></div>  
                          <div>{{ slotProps.value.code }}</div>
                      </div>
                      <span v-else>
                        {{ slotProps.placeholder }}
                      </span>
                    </template>
                    <template #option="slotProps">
                        <div class="flex align-items-center">
                            <div
                              class="color-box mr-2"
                              :style="{ backgroundColor: slotProps.option.colorHash }"
                            ></div>  
                            <div>{{ slotProps.option.code }}</div>
                        </div>
                    </template>
                    </PrimevueSelect>
                    <div
                      v-for="(error, index) of v$.selectedColor.$errors"
                      :key="index"
                      class="text-sm font-italic text-red-400"
                    >
                      {{ error.$message }}
                    </div>
                  </div>

                  <div class="flex justify-content-center mb-1">
                    <!-- Náhľad obrázka  -->
                    <div
                      class="mini-image-container" 
                      v-if="selectedProduct.product.image"
                    >
                      
                      <img :src="selectedProduct.product.image" 
                           :style="`${this.imageHeight >= this.imageWidth ? 'height:180px;' : 'width:260px;'}`"
                           @load="checkImageSize($event)"
                           alt="Preview Image" class="" />
                  
                    </div>
                    <div
                      class="image-container placeholder"
                      v-else
                    >
                    <i class="pi pi-image placeholder-icon"></i>
                    </div> 
                   
                  </div>

                  <div class="flex justify-content-center">
                    <PrimevueButton @click="addProduct()" :label="this.routeParams.typ == 1 ? 'Vyžiadať rezerváciu profilu' : 'Vyžiadať prestriekanie profilu'" 
                      :disabled="!(selectedProduct.id != 0)"
                      severity="success" icon="pi pi-plus-circle" text raised class="mt-1 w-11 md:w-11 lg:w-11 xl:w-10 uppercase"/>
                  </div>
                </div>
              </Fieldset>
            </div>
          </div> 

          <div class="w-12 p-0">  
            <Fieldset :legend="this.routeParams.typ == 1 ? 'Vyžiadané rezervácie profilov' : 'Vyžiadané prestriekania profilov'"  class="">
              <div class=" w-full ml-0 mr-0">
                <RequestProfileReserveList :typ="this.routeParams.typ" :resReqId="this.routeParams.resReqId" @delete-res-req="deleteResReq"></RequestProfileReserveList>
              </div> 
            </Fieldset>
          </div> 

            <div v-if="this.routeParams.resReqId > 0 && (store.user.admin === true || store.user.department.id == 3)" 
                 class="w-full pt-0 pl-0 pr-0 pb-0 flex justify-content-center">
                
                 <PrimevueButton @click="confirmDelete()" :label="this.routeParams.typ == 1 ? 'Odstrániť vyžiadanú rezerváciu' : 'Odstrániť vyžiadané prestriekanie'" 
                  v-tooltip.top="{ value: `${!this.deleteIsPossible ? 
                  (this.routeParams.typ == 1 ? 'Vyžiadanú rezerváciu je možné odstrániť iba ak boli odstránené všetky vyžiadané rezervácie produktov' : 
                    'Vyžiadané prestriekanie je možné odstrániť iba ak boli odstránené všetky vyžiadané prestriekania produktov' ) : ''}` }"
                severity="danger" icon="pi pi-trash" text raised class="w-11 md:w-7 lg:w-6 xl:w-5 mt-2 mb-2 uppercase"/>
            </div>
          
        </template>
    </PrimevueCard>

    <!--
    <PrimevueCard v-if="this.routeParams.resReqId > 0" class="sm:w-12 md:w-11 lg:w-11 xl:w-8" >
      <template #title>
        <div class="font-medium text-xl">
              {{this.routeParams.typ == 1 ? 'Vyžiadané rezervácie profilov' : 'Vyžiadané prestriekania profilov'}}
        </div>
      </template>
      <template #content>
        <RequestProfileReserveList :typ="this.routeParams.typ" :resReqId="this.routeParams.resReqId" @delete-res-req="deleteResReq"></RequestProfileReserveList>
      </template>
    </PrimevueCard>
    -->
    <ConfirmDialog></ConfirmDialog>
  </div>

</template>

<script lang="ts">
import Security from "@/components/security";
import {store} from "@/components/store";
import notie from "notie/dist/notie";
import router from "@/router";
import PrimevueButton from 'primevue/button';
import PrimevueSelect from "primevue/dropdown";
import PrimevueCard from 'primevue/card';
//import Utils from './utils';
import {emiter} from '../main';
import { required, helpers  } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import PrimevueTag from "primevue/tag";
import PrimevueCheckbox from 'primevue/checkbox';
import {FilterMatchMode} from "primevue/api";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import IconField from 'primevue/iconfield';
import InputIcon from "primevue/inputicon";
import Fieldset from 'primevue/fieldset';
import RequestProfileReserveList from "@/components/RequestProfileReserveList.vue";

const notBeZero = (value : number) => value > 0

const max = (param:number) =>
  helpers.withParams(
    { type: 'max', value: param },
    (value:number) => value <= param
  ) 

export default {
  name: "ReservationRequestEdit",
  components: {

      PrimevueButton,
      PrimevueSelect,
      PrimevueCard,
      PrimevueTag,
      PrimevueCheckbox,
      DataTable,
      Column,
      IconField,
      InputIcon,
      Fieldset,
      RequestProfileReserveList,
  },
  data() {
    return {
      store,
      imageWidth: 0,
      imageHeight:0,
      numberOfProd: 0,
      deleteIsPossible: false,
      reservationRequest: {
        id: 0,
        status: "Nová",
        order: {id:0,orderCode:"",customerLastName:"",customerFirstName:""},
        color: {id:0,code:""},
        
      },
      imitation: false,
      routeParams: null,
      colors: [],
      selectedColor: {id:0,code:""},
      productOptions: [],
      selectedProduct: {id:0,product:{code:"",image:""},numberOfItem:0 },
      orderOptions: [],
      selectedOrder: null,
      visibleSelect: false,
      selectLoading: false,
      orderFilters : {
          global: {value: null, matchMode: FilterMatchMode.CONTAINS},
      },
      selectParams: {
        first: 0,
        rows: 100,
        totalRecords: 0,
        filters:{global: "",
                 table:"order",
                 globalFilterFields: ['OrderCode', 'CustomerId__LastName','CustomerId__City']
                },

      },            
    }
  },
  setup () {
    return {
      v$: useVuelidate()
    }
  },

  validations () {
    return {

      selectedProduct: {
           product: { code: {required: helpers.withMessage('Product nesmie byť prázdny', required)},}
          }, 
           //length: { notBeZero: helpers.withMessage('Dĺžka nesmie byť nulová', notBeZero)},
      numberOfProd: { notBeZero: helpers.withMessage('Počet produktov (profilov) nesmie byť nulový', notBeZero),
                      max: helpers.withMessage('Počet produktov môže byť max. '+this.selectedProduct.numberOfItem, max(this.selectedProduct.numberOfItem))
      },
              

      selectedColor: {
           code: { required: helpers.withMessage('Farba nesmie byť prázdna', required)},
                
              },      
      selectedOrder: { required: helpers.withMessage('Objednávka nesmie byť prázdna', required)},
                
                   
    }
  },

  beforeRouteUpdate(to, from, next) {
      if (Security.requireToken()){
        this.routeParams = to.params
        store.selectModul = this.$route.path.split("/")[1]

        this.loadData()  

        next()
      }
  },

  beforeMount() {
    
    if (Security.requireToken()){
      
      this.routeParams = this.$route.params
      store.selectModul = this.$route.path.split("/")[1]

      this.loadData()
      emiter.on('reloadReservationRequest',this.loadData)
    }

  },
  methods: {

    loadData(){

      this.setColors()

      if (parseInt(String(this.routeParams.resReqId), 10) > 0) {
        
        const RequestId = String(this.routeParams.resReqId)

        let url = "/v1/reservation-request/"

        if (this.routeParams.typ == 2) {
           url = "/v1/spraying-request/"
        }
        fetch(store.Api_url + url + RequestId, Security.requestOptions("GET"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                notie.alert({
                      type: 'error',
                      text: responseData.message,
                      position: "top"
                })         
              } else {
                
                this.reservationRequest = responseData.data
                this.selectedOrder =  this.reservationRequest.order
                
                this.selectedProduct = {id:0,product:{code:"",image:""},numberOfItem:0 }
                this.numberOfProd = 0
                if (this.routeParams.typ == 1) {
                  this.selectedColor = this.reservationRequest.color
                  this.filterProducts(this.reservationRequest.color.id)
                }else{
                  this.selectedColor = this.reservationRequest.color
                  this.filterProducts(0)
                }
              }
            })
            .catch((error) => {
              //this.$emit('error', "Chyba pri načítaní balíka" + error);
              notie.alert({
                      type: 'error',
                      text: "Chyba pri načítaní žiadosti: " + error,
                      position: "top"
              })           
        })
      }
    },

    async addProduct(){
      
      const result = await this.v$.$validate()
      
      if (!result) {
        // notify user form is invalid
        return
      }
      const reqId = parseInt(String(this.routeParams.resReqId), 10)
      
      
      let formData = {
        id: 0,
        request: this.reservationRequest,
        order: this.selectedOrder,
        numberOfPieces: this.numberOfProd,
        product: this.selectedProduct.product,
        color: this.selectedColor,

      }

      const method = "POST"
      
      let url = "/v1/reservation-request"

      if (this.routeParams.typ == 2) {
          url = "/v1/spraying-request"
      }
      if (reqId > 0){
          url = "/v1/request-profile-reserve"
        
        if (this.routeParams.typ == 2) {
          url = "/v1/request-profile-spray"
        }
      }

      fetch(store.Api_url + url, Security.requestOptions(method, formData))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
            
              notie.alert({
                type: 'error',
                text: responseData.message
              })
            } else {
              notie.alert({
                type: 'success',
                text: "Žiadosť bola uložená"
              })
              if (reqId == 0){
                 this.reservationRequest = responseData.data
              }
              
              //this.addStockMovement()

              this.v$.$reset()

              if (reqId > 0){
                this.loadData()
              }else{
                router.push("/mod-stock/reservation-requests/"+this.routeParams.typ+"/"+String(this.reservationRequest.id));
              }
              emiter.emit('reloadReqProfRes')
              
            }
          })
          .catch((error) => {
            //this.$emit('error', "Chyba pri žiadosti o rezerváciu" + error);
            notie.alert({
              type: 'error',
              text: "Chyba pri žiadosti " + error
            })
          })

    },

    deleteResReq(deleted:boolean){
      this.deleteIsPossible = deleted
      //console.log("delete-Is-Possible");
    },

    confirmDelete() {
      if (this.deleteIsPossible){
        this.$confirm.require({
            message: 'Naozaj chcete odstrániť žiadosť o rezerváciu?',
            header: 'Odstránenie žiadosti o rezerváciu',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: "Áno",
            rejectLabel: "Nie",

            accept: () => {
              this.deleteReservationRequest()
            },

        });
      }
    },

    deleteReservationRequest(){
      //if(confirm("Naozaj chcete ODSTRÁNIŤ objednávku?")){
        Security.requireToken();
        fetch(store.Api_url + "/v1/reservation-request/" + String(this.reservationRequest.id), Security.requestOptions("DELETE"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                //console.log("error:", responseData.message);
                this.$emit('error', responseData.message);
                notie.alert({
                    type: 'error',
                    text: "Žiadosť o rezerváciu sa nepodarilo odstrániť: " + responseData.message,
                    position: "top"
                  })           
              } else {

                notie.alert({
                  type: 'success',
                  text: "Žiadosť o rezerváciu bola odstránená",
                  position: "bottom"
                })
                 router.push("/mod-stock/reservation-requests")
              }
            })
            .catch((error) => {
              alert('Chyba pri odstránení: ' + error)
            })
      //}
    },
   
    filterProducts(colorId:number){
      
      fetch(this.store.Api_url + "/v1/filter-products/"+colorId, Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
             
              notie.alert({
                type: 'error',
                text: "Zoznam produktov sa nepodarilo načítať"
              })
            } else {
              if (responseData.data) {
                 this.productOptions = responseData.data
              }else{
                this.productOptions = []
              }

            }
          })
          .catch((error) => {
            //this.$emit('error', "Chyba pri načítaní produktov" + error);
            notie.alert({
                type: 'error',
                text: "Chyba pri načítaní zoznamu produktov: "+error
              })
      })
    },

    checkImageSize(event) {
      this.imageWidth = event.target.naturalWidth;
      this.imageHeight = event.target.naturalHeight;
    },

    setColors(){

      const imitat = this.imitation ? "1" : "0"

      fetch(this.store.Api_url + "/v1/color?query=deleted:0,imitation:"+imitat, Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
            
              notie.alert({
                type: 'error',
                text: "Zoznam farieb sa nepodarilo načítať"
              })
            } else {
              this.colors = responseData.data
            }
          })
          .catch((error) => {
            notie.alert({
                type: 'error',
                text: "Chyba pri načítaní farieb: "+error
              })
            //this.$emit('error', "Chyba pri načítaní farieb" + error);
      })
    },

    closeForm(){
      router.push("/mod-stock/packages")
    },

    selectOrder(){

       this.visibleSelect = false
       this.reservationRequest.order = this.selectedOrder
       if (this.routeParams.typ == 2){
        this.filterProducts(0)
       }
       //this.reservationRequest.order.customerFirstName = this.selectedOrder.customerFirstName
    },
    onOrderPage(event) {
      this.selectParams.first = event.first; // PrimeVue page is zero-based; adjust if your API is 1-based

      this.loadLazyDataOrders(this.selectParams)
    },

    onOrderFilter() {
      this.selectParams.filters.global = this.orderFilters.global.value
      this.selectParams.first = 0
      
      if(this.selectParams.filters.global.length > 2){
        this.loadLazyDataOrders(this.selectParams)
        }
    },

    initOrders(){

      this.visibleSelect = !this.visibleSelect
      this.selectParams.first = 0
      this.selectParams.rows = 100
      this.selectParams.filters.global = ""
      this.orderfilters = {
          global: {value: null, matchMode: FilterMatchMode.CONTAINS},

      }
      this.loadLazyDataOrders(this.selectParams)
      //this.isMovement = false
      //this.typeOfAction = ""
      //this.typeOfMultiPackAction = ""
    },


    loadLazyDataOrders(params) {
        this.selectLoading = true;

        let queryParams = `&limit=${params.rows}&offset=${(params.first)}`;

        fetch(`${store.Api_url}${this.store.basicUrlFilterOrders}${queryParams}`, Security.requestOptions("POST",params.filters))
        .then((response) => response.json())
        .then((responseData) => {
          if (!responseData.error) {
            if (responseData.data){
              this.orderOptions = responseData.data
            }else{
              this.orderOptions = []
            }
            this.selectParams.totalRecords = responseData.totalRecords
            this.selectLoading = false;
          }
        })
        .catch((error) => {
          this.orderOptions = []
          this.selectLoading = false;
        })
    },
  },

  beforeUnmount(){
        emiter.off('reloadReservationRequest',this.loadData)
        
  },  
}
</script>



<style scoped>

</style>




